import { request } from 'network/queue';

const POLLING_RATE_IN_MILLISEC = 1000;

function fetchJobStatus(query, variables, resolve, reject) {
  setTimeout(async () => {
    const { job } = await request({ query, variables, fetchPolicy: 'no-cache' });
    if (!job) {
      reject('Job cannot Find');
      return;
    }
    if (['COMPLETED', 'FAILED'].includes(job?.status)) {
      resolve(job?.result);
    } else {
      fetchJobStatus(query, variables, resolve, reject);
    }
  }, POLLING_RATE_IN_MILLISEC);
}

function pollJobStatus(query, variables) {
  return new Promise((res, rej) => {
    fetchJobStatus(query, variables, res, rej);
  });
}

function waitForDeferredResult(response, jobFragment) {
  const {
    request: {
      errors,
      job: { id, status, result },
    },
  } = response;
  if (errors?.length) return false;
  return (
    ['COMPLETED', 'FAILED'].includes(status)
      ? new Promise((res) => res(result))
      : pollJobStatus(jobFragment, { jobId: id })
  );
}

export default waitForDeferredResult;
